module.exports = __webpack_public_path__ + "img/product_sk-ii_3.bb578dc0.png";